// extracted by mini-css-extract-plugin
export default {"ErrorBadge":"ErrorBadge-Y8jC6COOQiI"};